import api from './api';

export interface StockLot {
  lot_id: number;
  lot_number: string;
  expiry_date: string;
  available_quantity: number;
  cost_price: number;
  supplier_name: string;
}

export const stockService = {
  // Lấy thông tin tồn kho theo lô của một thuốc
  getMedicineStock: async (medicineId: number): Promise<StockLot[]> => {
    const response = await api.get(`/api/stock/medicine/${medicineId}/stock`);
    return response.data.data;
  },

  // Lấy danh sách phiếu nhập kho
  getStockInVouchers: async (params?: any) => {
    const response = await api.get('/api/stock/in', { params });
    return response.data.data;
  },

  // Lấy danh sách phiếu xuất kho
  getStockOutVouchers: async (params?: any) => {
    const response = await api.get('/api/stock/out', { params });
    return response.data.data;
  },

  // Tạo phiếu nhập kho
  createStockInVoucher: async (data: any) => {
    const response = await api.post('/api/stock/in', data);
    return response.data;
  },

  // Tạo phiếu xuất kho
  createStockOutVoucher: async (data: any) => {
    const response = await api.post('/api/stock/out', data);
    return response.data;
  },

  // Lấy chi tiết phiếu nhập kho
  getStockInVoucherDetail: async (id: number) => {
    const response = await api.get(`/api/stock/in/${id}`);
    return response.data.data;
  },

  // Lấy chi tiết phiếu xuất kho
  getStockOutVoucherDetail: async (id: number) => {
    const response = await api.get(`/api/stock/out/${id}`);
    return response.data.data;
  },

  // Hoàn thành phiếu nhập kho
  completeStockInVoucher: async (id: number) => {
    const response = await api.post(`/api/stock/in/${id}/complete`);
    return response.data;
  },

  // Hoàn thành phiếu xuất kho
  completeStockOutVoucher: async (id: number) => {
    const response = await api.post(`/api/stock/out/${id}/complete`);
    return response.data;
  },

  // Cập nhật phiếu nhập kho
  updateStockInVoucher: async (id: number, data: any) => {
    const response = await api.put(`/api/stock/in/${id}`, data);
    return response.data;
  },

  // Cập nhật phiếu xuất kho
  updateStockOutVoucher: async (id: number, data: any) => {
    const response = await api.put(`/api/stock/out/${id}`, data);
    return response.data;
  },

  // Xóa phiếu nhập kho
  deleteStockInVoucher: async (id: number) => {
    const response = await api.delete(`/api/stock/in/${id}`);
    return response.data;
  },

  // Xóa phiếu xuất kho
  deleteStockOutVoucher: async (id: number) => {
    const response = await api.delete(`/api/stock/out/${id}`);
    return response.data;
  },

  // Xóa cưỡng bức phiếu xuất kho đã hoàn thành (Tools)
  forceDeleteStockOutVoucher: async (id: number) => {
    const response = await api.delete(`/api/stock/out/${id}/force`);
    return response.data;
  },

  // Lấy mã phiếu tiếp theo (preview) - không tạo phiếu
  getNextStockOutVoucherNumber: async (): Promise<string> => {
    const response = await api.get('/api/stock/out/next-voucher-number');
    return response.data.voucher_number;
  }
}; 